import * as contactUsApi  from "@/api/contactUs";
import routerPath from "@/router/routerPath";

const state = {
  name: '',
  baseParameter:{},
  routerPath,
}

const mutations = {
  SET_BASEPARAMETER: (state, baseParameter) => {
    state.baseParameter = baseParameter
  },
}

const actions = {
  getInfo({ commit}) {
    return new Promise((resolve, reject) => {
      contactUsApi.read().then(response => {
        const { data } = response
        commit('SET_BASEPARAMETER', data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  resetScrollTop() {
      document.getElementById("pageMain").scrollTop = 0;
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
